import { render, staticRenderFns } from "./DeliveryLocationDialog.vue?vue&type=template&id=1c13c062&scoped=true"
import script from "./DeliveryLocationDialog.vue?vue&type=script&lang=ts"
export * from "./DeliveryLocationDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryLocationDialog.vue?vue&type=style&index=0&id=1c13c062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13c062",
  null
  
)

export default component.exports